
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"#D95555"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.06 12.76l-2.171 2.166-2.171-2.171a.68.68 0 10-.963.963l2.17 2.17-2.17 2.172a.68.68 0 00.963.963l2.17-2.171 2.172 2.17a.682.682 0 001.162-.48.682.682 0 00-.2-.482l-2.17-2.171 2.17-2.171a.683.683 0 000-.958m-.962 0a.68.68 0 01.963 0","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.92 5.537L7.826 9.63 6.518 8.32a.694.694 0 10-.981.981l1.802 1.803c.272.272.71.272.982 0l4.587-4.587a.693.693 0 000-.981.702.702 0 00-.989 0z","fill":"#fff"}})])
          )
        }
      }
    